// eslint-disable-next-line import/no-dynamic-require
const images = require(`../../../public/images/${process.env.NEXT_PUBLIC_CUSTOMER}/images.json`);

const Image = ({ src, alt, ...others }) => (
  <img src={`/images/${process.env.NEXT_PUBLIC_CUSTOMER}/${images[src]}`} alt={alt} {...others} />
);

export default Image;
